// extracted by mini-css-extract-plugin
export default {"blueBtn":"buttons_blueBtn__vy6Kr","defaultButton":"buttons_defaultButton__Q7xkJ"};